<template>
  <el-row justify="center" type="flex">

    <el-col :xs="24" :sm="12">

      <h1>{{ $t('login.welcome') }}</h1>

      <data-form
        :entity="model"
        :fields="fields"
        :cancel="false"
        :loading="$store.state.progress > 0"
        submit-label="login"
        @submit="submit" />

    </el-col>

  </el-row>
</template>

<script>
import auth from 'providers/auth.js'

export default {
  name: 'login',
  data () {
    return {
      model: {
        email: '',
        password: ''
      },
      fields: {
        email: {
          type: 'email',
          rules: [{ required: true }, { type: 'email' }]
        },
        password: {
          type: 'password',
          rules: [{ required: true }]
        }
      }
    }
  },
  methods: {
    async submit (model) {
      try {
        await auth.login(model.email, model.password)

        const redirect = this.$route.query.redirect || '/'

        this.$router.push(redirect)
      }
      catch (err) {
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?3fc89c45